import {
  Stack,
  Text,
  Box,
  Button,
  IconTick,
  Heading,
  HiddenVisually,
  IconPromote,
} from 'braid-design-system';

import * as styles from './DesktopPackageColumns.css';

interface DesktopPackageColumnsProps {
  onFreemiumClick: () => void;
  onStandardClick: () => void;
  onAccelerateClick: () => void;
  htags: {
    freemium: string;
    standard: string;
    accelerate: string;
  };
}

export const DesktopPackageColumns = (props: DesktopPackageColumnsProps) => (
  <Box>
    <Box className={styles.row} background="surface">
      <Box className={styles.cellFirstRow}>
        <EmptyCell />
      </Box>

      <Box className={styles.cellFirstRow}>
        <EmptyCell />
      </Box>

      <Box className={styles.cellFirstRow}>
        <Text
          icon={<IconPromote />}
          align="center"
          weight="strong"
          tone="promote"
        >
          Recommended
        </Text>
      </Box>

      <Box className={styles.cellFirstRow}>
        <EmptyCell />
      </Box>
    </Box>

    <Box className={styles.row} background="surface">
      <Box className={styles.cellHeading}>
        <EmptyCell />
      </Box>

      <Box
        className={styles.cellHighlightBrandAccent}
        background="surface"
        data={{ testid: 'desktop-package-header-cell-freemium' }}
      >
        <Stack space="medium">
          <Text tone="brandAccent" size="large" weight="strong">
            Free
          </Text>

          <Text>Starting your selling journey</Text>
        </Stack>
      </Box>

      <Box
        className={styles.cellHighlightPromote}
        background="surface"
        data={{ testid: 'desktop-package-header-cell-standard' }}
      >
        <Stack space="medium">
          <Text tone="promote" size="large" weight="strong">
            Standard
          </Text>

          <Text>Get noticed by more buyers</Text>

          <Stack space="small" data={{ testid: 'package-price' }}>
            <Heading weight="weak" level="2" align="center">
              $949
            </Heading>
            <Text size="small">+ GST</Text>
          </Stack>
        </Stack>
      </Box>

      <Box
        className={styles.cellHighlightBrandAccent}
        background="surface"
        data={{ testid: 'desktop-package-header-cell-accelerate' }}
      >
        <Stack space="medium">
          <Text tone="brandAccent" size="large" weight="strong">
            Accelerate
          </Text>

          <Text>Reach the right buyers faster</Text>

          <Stack space="small" data={{ testid: 'package-price' }}>
            <Heading weight="weak" level="2" align="center">
              $1299
            </Heading>
            <Text size="small">+ GST</Text>
          </Stack>
        </Stack>
      </Box>
    </Box>

    <Box className={styles.row} background="neutralLight">
      <Box className={styles.cellHeading}>
        <Text>Listing duration</Text>
      </Box>

      <Box className={styles.cell} background="neutralLight">
        <Box
          display="flex"
          height="full"
          alignItems="center"
          justifyContent="center"
        >
          <Text>6 months</Text>
        </Box>
      </Box>

      <Box className={styles.cell} background="neutralLight">
        <Box
          display="flex"
          height="full"
          alignItems="center"
          justifyContent="center"
        >
          <Text>List until sold</Text>
        </Box>
      </Box>

      <Box className={styles.cell} background="neutralLight">
        <Box
          display="flex"
          height="full"
          alignItems="center"
          justifyContent="center"
        >
          <Text>List until sold</Text>
        </Box>
      </Box>
    </Box>

    <Box className={styles.row} background="surface">
      <Box className={styles.cellHeading}>
        <Text>Appear on Australia&apos;s #1 business marketplace</Text>
      </Box>

      <Box className={styles.cell} background="surface">
        <TickCell />
      </Box>

      <Box className={styles.cell} background="surface">
        <TickCell />
      </Box>

      <Box className={styles.cell} background="surface">
        <TickCell />
      </Box>
    </Box>

    <Box className={styles.row} background="neutralLight">
      <Box className={styles.cellHeading}>
        <Text>Receive emails from interested buyers</Text>
      </Box>

      <Box className={styles.cell} background="neutralLight">
        <TickCell />
      </Box>

      <Box className={styles.cell} background="neutralLight">
        <TickCell />
      </Box>

      <Box className={styles.cell} background="neutralLight">
        <TickCell />
      </Box>
    </Box>

    <Box className={styles.row} background="surface">
      <Box className={styles.cellHeading}>
        <Text>Photo included in search results</Text>
      </Box>

      <Box className={styles.cell} background="surface">
        <EmptyCell />
      </Box>

      <Box className={styles.cell} background="surface">
        <TickCell />
      </Box>

      <Box className={styles.cell} background="surface">
        <TickCell />
      </Box>
    </Box>

    <Box className={styles.row} background="neutralLight">
      <Box className={styles.cellHeading}>
        <Text>Appear higher in search results</Text>
      </Box>

      <Box className={styles.cell} background="neutralLight">
        <EmptyCell />
      </Box>

      <Box className={styles.cell} background="neutralLight">
        <TickCell />
      </Box>

      <Box className={styles.cell} background="neutralLight">
        <TickCell />
      </Box>
    </Box>

    <Box className={styles.row} background="surface">
      <Box className={styles.cellHeading}>
        <Text>Include in daily buyer recommendation emails</Text>
      </Box>

      <Box className={styles.cell} background="surface">
        <EmptyCell />
      </Box>

      <Box className={styles.cell} background="surface">
        <TickCell />
      </Box>

      <Box className={styles.cell} background="surface">
        <TickCell />
      </Box>
    </Box>

    <Box className={styles.row} background="neutralLight">
      <Box className={styles.cellHeading}>
        <Text>Feature at the top of search results</Text>
      </Box>

      <Box className={styles.cell} background="neutralLight">
        <EmptyCell />
      </Box>

      <Box className={styles.cell} background="neutralLight">
        <EmptyCell />
      </Box>

      <Box className={styles.cell} background="neutralLight">
        <TickCell />
      </Box>
    </Box>

    <Box className={styles.row} background="surface">
      <Box className={styles.cellHeading}>
        <Text>Priority placement in daily buyer recommendation emails</Text>
      </Box>

      <Box className={styles.cell} background="surface">
        <EmptyCell />
      </Box>

      <Box className={styles.cell} background="surface">
        <EmptyCell />
      </Box>

      <Box className={styles.cell} background="surface">
        <TickCell />
      </Box>
    </Box>

    <Box className={styles.row} background="surface">
      <Box className={styles.cellHeading}>
        <EmptyCell />
      </Box>

      <Box display="flex" className={styles.footerCell} background="surface">
        <Button
          tone="formAccent"
          onClick={props.onFreemiumClick}
          data={{ htag: props.htags.freemium }}
        >
          Choose Free
        </Button>
      </Box>

      <Box display="flex" className={styles.footerCell} background="surface">
        <Button
          tone="formAccent"
          onClick={props.onStandardClick}
          data={{ htag: props.htags.standard }}
        >
          Choose Standard
        </Button>
      </Box>

      <Box display="flex" className={styles.footerCell} background="surface">
        <Button
          tone="formAccent"
          onClick={props.onAccelerateClick}
          data={{ htag: props.htags.accelerate }}
        >
          Choose Accelerate
        </Button>
      </Box>
    </Box>
  </Box>
);

const TickCell = () => (
  <Box display="flex" height="full" alignItems="center" justifyContent="center">
    <IconTick tone="info" size="large" />
  </Box>
);

const EmptyCell = () => (
  <Box>
    <HiddenVisually>Not offered</HiddenVisually>
  </Box>
);
